import React, { useEffect, useState } from "react";
import { Descriptions, Button, message, Spin, Skeleton } from "antd";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import Axios from "axios";
import { apiRoutes, environment } from "../../auth/apiRoute";
import LoadingFrame from "../../layout/loadingFrame";
export default function MyProfile(props) {
  const [myProfile, setMyProfile] = useState({});
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getMyProfile();
  }, []);
  const getMyProfile = async () => {
    setLoading(true);
    console.log(props.user);
    try {
      const response = await Axios.post(apiRoutes[environment].getprofile);
      console.log(response.data);
      if (response.status == 200) {
        setMyProfile(response.data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const managedHotel = () => {
    if (myProfile.hotels) {
      return myProfile.hotels.map((item) => {
        return (
          <li key={item.name}>
            <Link to={"/hotels/" + item._id}>{item.name}</Link>

            <br />
          </li>
        );
      });
    }
  };
  return (
    <div>
      <LoadingFrame loading={loading}>
        <Descriptions
          loading={loading}
          title="My Profile"
          bordered
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}
          extra={
            <Button type="primary">
              <Link to={`/member/${myProfile._id}/profile`}>Edit</Link>
            </Button>
          }
        >
          <Descriptions.Item label="First Name">
            {myProfile.firstName}
          </Descriptions.Item>
          <Descriptions.Item label="Last Name">
            {myProfile.lastName}
          </Descriptions.Item>
          <Descriptions.Item label="Email">{myProfile.email}</Descriptions.Item>
          <Descriptions.Item label="Phone">{myProfile.phone}</Descriptions.Item>
          <Descriptions.Item label="Position">
            {myProfile.title}
          </Descriptions.Item>
          <Descriptions.Item label="Managed Hotels">
            {managedHotel()}
          </Descriptions.Item>
        </Descriptions>
      </LoadingFrame>

      {/* <Spin spinning={loading}></Spin> */}
    </div>
  );
}
